export const ItemTypes = {
  DICOM: "dicom",
};
